export enum LoanConditionalOptions {
  FixedRates = 'Fixed Rates',
  NoPrepaymentPenalty = 'No Prepayment Penalty',
  NoEquityAndNoAppraisal = 'No Equity & No Appraisal',
  QuickFunding = 'Quick Funding for Any Home Improvements',
  DirectToConsumerFunded = '100% Direct-to-Consumer Funded',
}

export enum Text {
  TranscriptAuthorization = 'Tax Transcript Authorization',
  Proceed = 'Proceed',
  Decline = 'Decline',
}
